/**
 * Copyright (c) 2022 Schwäbische Werkzeugmaschinen GmbH
 *
 * @author Sebastian Roming
 * @since 5.0.0
 */
export const LdLoginMessages: any = {
  'unspecified': {
    'error': true,
    'http_status_code': 401,
    'internal_status_code': null,
    'toast_duration': 0,
    'highlight_input': false,
    'disable_input': false,
    'message': 'An unspecified error occurred. Please try again later.'
  },
  'wrong_credentials': {
    'error': true,
    'http_status_code': 401,
    'internal_status_code': null,
    'toast_duration': 0,
    'highlight_input': true,
    'disable_input': false,
    'message': 'Your e-mail and/or password is incorrect. Please try again.'
  },
  'no_credentials': {
    'error': true,
    'http_status_code': 401,
    'internal_status_code': null,
    'toast_duration': 0,
    'highlight_input': true,
    'disable_input': false,
    'message': 'Please specify an e-mail and a password.'
  },
  'session_timeout': {
    'error': true,
    'http_status_code': 401,
    'internal_status_code': null,
    'toast_duration': 0,
    'highlight_input': false,
    'disable_input': false,
    'message': 'Your session expired due to inactivity. Please login again.'
  },
  'locked': {
    'error': true,
    'http_status_code': 423,
    'internal_status_code': null,
    'toast_duration': 0,
    'highlight_input': false,
    'disable_input': false,
    'message': 'Your account is temporarily locked. Please try again later.'
  },
  'password_change_successful': {
    'error': false,
    'http_status_code': 201,
    'internal_status_code': null,
    'toast_duration': 5000,
    'highlight_input': false,
    'disable_input': false,
    'message': 'Your password change request has been recorded successfully. Please check your e-mail account for further instructions.'
  },
  'no_connection': {
    'error': false,
    'http_status_code': null,
    'internal_status_code': null,
    'toast_duration': 5000,
    'highlight_input': false,
    'disable_input': false,
    'message': 'It seems that you are not connected to the internet. Please ensure you are connected.'
  },
  'not_supported_browser': {
    'error': true,
    'http_status_code': null,
    'internal_status_code': null,
    'toast_duration': 0,
    'highlight_input': false,
    'disable_input': true,
    'message': 'You are using an unsupported Browser. The CloudPlatform needs one of the following browsers: Google Chrome, Microsoft Edge, Apple Safari.'
  },
  'NotAuthorizedException': {
    'error': true,
    'http_status_code': 400,
    'message': 'Your old password is incorrect. Please try again.'
  },
  'change_pw_required': {
    'message': 'Before your first login, you need to change your temporary password.'
  },
  'force_change_password_success': {
    'error': false,
    'toast_duration': 5000,
    'message_type': 'SUCCESS',
    'message': 'Your password has been changed successfully.',
    'link_text': 'Please click here to continue'
  },
  'force_change_password_error': {
    'error': true,
    'toast_duration': 0,
    'message_type': 'ERROR',
    'message': 'Your password could not be changed. Please try again.'
  },
  'verify_email': {
    'message': 'Please enter the verification code that has been sent to your e-mail address.'
  },
  'UserNotConfirmedException': {
    'error': true,
    'http_status_code': 401,
    'internal_status_code': null,
    'toast_duration': 0,
    'highlight_input': true,
    'disable_input': false,
    'message': 'You first need to verify your account. Therefore an verification code has been sent to your e-mail account.'
  },
  'forgot_password_code_sent': {
    'message': 'A verification code has been sent to your e-mail address. Please use this code to set a new password.'
  },
  'no_verification_code_entered': {
    'message': 'You need to enter the verification code sent to your e-mail address.'
  }
};
